import {
  AccountBookOutlined,
  AlertOutlined,
  AppstoreAddOutlined,
  BankOutlined,
  BarChartOutlined,
  CarOutlined,
  ContainerOutlined,
  CopyOutlined,
  CreditCardFilled,
  CreditCardOutlined,
  DollarOutlined,
  ExceptionOutlined,
  FileAddOutlined,
  FileOutlined,
  FileSearchOutlined,
  FileSyncOutlined,
  FileTextOutlined,
  FireOutlined,
  FolderAddOutlined,
  FolderOpenFilled,
  FolderViewOutlined,
  HomeFilled,
  HomeOutlined,
  ImportOutlined,
  InboxOutlined,
  PercentageOutlined,
  ReconciliationOutlined,
  ScheduleOutlined,
  SwapOutlined,
  TeamOutlined,
  UserAddOutlined,
  UserOutlined,
} from '@ant-design/icons';
import { Institucion, RouteI, User } from 'sigt';
import Wallets from './components/Charges/Wallets';
import RegisterCodominium from './components/Condominiums/RegisterCodominium';
import ConsultPenalty from './components/ConsultPenalty';
import AffairsForm from './components/Forms/AffairsForm';
import CertificadeView from './components/Forms/CertificadeView';
import LicenseLiqueurForm from './components/Forms/LicenseLiqueurForm';
import OfficialPFForm from './components/Forms/PassangerFee/OfficialPFForm';
import IMATicketForm from './components/Forms/Ticket/IMATicketForm';
import PoliceTicketForm from './components/Forms/Ticket/PoliceTicketForm';
import TaxpayerServices from './components/MunicipalServices/TaxpayerServices';
import Scale from './components/Scale';
import TableActivities from './components/Tables/TableActivities';
import TableBankCalendar from './components/Tables/TableBankCalendar';
import TableCharge from './components/Tables/TableCharge';
import TableCPUPayments from './components/Tables/TableCPUPayments';
import TableDestination from './components/Tables/TableDestination';
import TableEditUser from './components/Tables/TableEditUser';
import TableFiscalValue from './components/Tables/TableFiscalValues';
import TableInspection from './components/Tables/TableInspection';
import TableMovements from './components/Tables/TableMovements';
import TableOfficials from './components/Tables/TableOfficial';
import RimDocuments from './components/RimDocuments';
import TableProcedure from './components/Tables/TableProcedure';
import TableReceipt from './components/Tables/TableReceipt';
import TableRetentions from './components/Tables/TableRetentions';
import TableSupport from './components/Tables/TableSupport';
import ActivityChange from './components/Taxes/ActivityChange';
import Agents from './components/Taxes/Agents';
import AmendPayments from './components/Taxes/Amendment/AmendPayments';
import AmendSettlements from './components/Taxes/Amendment/AmendSettlements';
import BenefitTribTaxes from './components/Taxes/BenefitTrib';
import AgreementTaxPayer from './components/Taxes/BenefitTrib/AgreementTaxPayer';
import CleaningFee from './components/Taxes/CleaningFee';
import DeclareAnualAE from './components/Taxes/DeclareAnualAE';
import DeclareAnyTaxes from './components/Taxes/DeclareAnyTaxes';
import Fixes from './components/Taxes/Fixes/Fixes';
import InternalBranchRegister from './components/Taxes/Internal/InternalBranchRegister';
import InternalLicense from './components/Taxes/Internal/InternalLicense';
import InternalLinking from './components/Taxes/Internal/InternalLinking';
import InternalPayments from './components/Taxes/Internal/InternalPayments';
import InternalRegister from './components/Taxes/Internal/InternalRegister';
import SpecialSettlements from './components/Taxes/Internal/SpecialSettlements';
import PendingRequests from './components/Taxes/PendingRequests';
import Retentions from './components/Taxes/Retentions';
import SMSettlements from './components/Taxes/SMSettlements';
import SubstituteStatement from './components/Taxes/SubstituteStatement';
import SupplementaryStatement from './components/Taxes/SupplementaryStatement';
import GetVehicleInfo from './components/Taxes/Vehicles/GetVehicleInfo';
import ConsultSolventStatus from './components/Taxpayer/ConsultSolventStatus';
import SupportSuite from './components/Taxes/SupportSuite';
import ConsultTaxpayer from './components/Taxpayer/ConsultTaxpayer';
import ConsultProperty from './components/UrbanEstates/ConsultProperty';
import RegisterProperty from './components/UrbanEstates/RegisterProperty';
import TaxPayerUrbanEstates from './components/UrbanEstates/TaxPayerUrbanEstates';
import ValidatePayments from './components/ValidatePayments';
import TableAuditMovements from './components/Tables/TableAuditMovements';

enum UserType {
  SuperUser = 1,
  OfficialAdmin,
  Official,
  External,
  OfficialChief,
}

export enum CargoEcodeba {
  Master = 43,
  Cajero = 103,
  GestionGerencial = 105,
  GestionAdministrativa,
}

export enum CargoCpu {
  Administrador = 5,
  Funcionario,
  DirectorOMPU = 17,
  DirectorOMCAT,
  DirectorOMTU,
  AnalistaValuacionFiscal = 46,
  JefeValuacionFiscal,
  AnalistaCodigoCatastral = 93,
  JefeCodigoCatastral,
  AnalistaNomenclatura,
  JefeNomenclatura,
}

export enum CargoSedemat {
  Cajero = 22,
  AnalistaPoliticasTributarias,
  Administrador,
  JefeDeCaja,
  GerenteCobranzas,
  GerentePoliticasTributarias,
  JefeServiciosMunicipales,
  JefeInmueblesUrbanos,
  JefeActividadesEconomicas,
  JefeAuditorias,
  JefeContribuyentesEspeciales,
  AnalistaCobranzas,
  Validador,
  GerenteGeneral,
  JefeDeCuadra,
  GerenteAdministracion,
  Soporte,
  JefeFiscalizacion,
  CajeroIntegral,
  CajeroE,
  GerenteRecaudacion,
  AnalistaLicores = 44,
  GerenteLicores,
  Auditor = 48,
  JefeDeTransacciones,
  AnalistaCondominios = 53,
  JefeDeZona,
  DirectorUrbanismo = 55,
  GerenteGeneralA,
  JefeContaduria = 89,
  Master,
  ConsultorLiquidaciones,
  analistaLiquidacionesEspeciales = 97,
  analistaInmueblesUrbanos,
  analistaConsultorInmuebles,
  MasterSoporte = 104,
  GerenteGeneralE = 107,
}

const canSupport = [
  CargoSedemat.Administrador,
  CargoSedemat.Master,
  CargoSedemat.Soporte,
  CargoSedemat.GerenteCobranzas,
  CargoSedemat.GerentePoliticasTributarias,
  CargoSedemat.GerenteRecaudacion,
  CargoSedemat.CajeroE,
  CargoCpu.JefeCodigoCatastral,
  CargoCpu.JefeValuacionFiscal,
  CargoCpu.JefeNomenclatura,
  CargoSedemat.CajeroIntegral,
  CargoSedemat.JefeDeCaja,
];

export const getRoutes = (user: User, institutions: Institucion[]): RouteI[] => {
  const routes: RouteI[] = [];
  const moneySubmenu: any[] = [
    {
      path: 'finanzas/validacionDePagos',
      exact: true,
      title: 'Validación de Pagos',
      component: ValidatePayments,
    },
  ];

  if ((user.tipoUsuario === UserType.OfficialAdmin && user.institucion?.id !== 0) || user.tipoUsuario === UserType.SuperUser) {
    if (UserType.OfficialAdmin === user.tipoUsuario) {
      // if (user.institucion.nombreCorto !== 'SEDETEMA') {
      //   moneySubmenu.push({
      //     path: 'finanzas/costosDeTramites',
      //     exact: true,
      //     title: 'Costos de Tramites',
      //     component: TableCosts,
      //   });
      // }

      if (user.institucion.nombreCorto === 'SAT') {
        moneySubmenu.push({
          path: 'fechaBancaria',
          exact: false,
          title: 'Fechas Bancarias',
          component: TableBankCalendar,
        });
        moneySubmenu.push({
          path: 'finanzas/alicuotas',
          exact: true,
          title: 'Administrar Alicuotas',
          component: TableActivities,
        });
      }

      // if (user.institucion.nombreCorto === 'CPU') {
      //   moneySubmenu.push({
      //     path: 'finanzas/valoresFiscales',
      //     exact: true,
      //     title: 'Valores Fiscales',
      //     component: TableFiscalValue,
      //   });
      // }
    }

    if ((user.tipoUsuario === UserType.OfficialAdmin && user.institucion.id === 9) || user.institucion?.cargo?.id === 35)
      moneySubmenu.push({
        path: 'finanzas/baremo',
        exact: false,
        title: 'Baremo de Tarifas',
        component: Scale,
      });

    if (user.tipoUsuario === UserType.OfficialAdmin && ![3, 10].includes(user.institucion.id))
      routes.push({
        path: 'finanzas',
        exact: true,
        icon: DollarOutlined,
        title: 'Finanzas',
        subMenu: moneySubmenu,
      });

    if (
      UserType.OfficialAdmin === user.tipoUsuario &&
      user.institucion.nombreCorto !== 'SEDETEMA' &&
      user.institucion.nombreCorto !== 'CPU'
    )
      if (UserType.OfficialAdmin === user.tipoUsuario && user.institucion.nombreCorto === 'SEDETEMA')
        // moneySubmenu.push({
        //   path: 'ordenanzas',
        //   exact: false,
        //   title: 'Ordenanzas',
        //   component: TableOrdinance,
        // });

        moneySubmenu.push({
          path: 'destinos',
          exact: false,
          title: 'Tasas de Destinos',
          component: TableDestination,
        });
  }

  if (user.institucion?.nombreCorto === 'PMM') {
    routes.push({
      path: 'consultarMultas',
      exact: true,
      title: 'Consultar Impuesto de Vehiculos y Multas',
      icon: FileSearchOutlined,
      component: ConsultPenalty,
    });
  }

  //MENU DE RUTAS SEDEMAT
  if (user.institucion?.nombreCorto === 'SAT') {
    // Bandeja Cargos Hacienda
    const havePrcd = [
      CargoSedemat.GerentePoliticasTributarias,
      CargoSedemat.GerenteGeneral,
      CargoSedemat.AnalistaPoliticasTributarias,
      CargoSedemat.AnalistaLicores,
      CargoSedemat.GerenteLicores,
      CargoSedemat.GerenteRecaudacion,
      CargoSedemat.analistaLiquidacionesEspeciales,
      CargoSedemat.analistaInmueblesUrbanos,
      CargoSedemat.CajeroIntegral,
      CargoSedemat.JefeDeCaja,
      CargoSedemat.GerenteGeneralE,
    ];

    const subMenuCorrecciones: RouteI[] = [];

    const correccionPagos = {
      path: 'correcciones/pagos',
      exact: true,
      title: 'Corrección de Pagos',
      component: AmendPayments,
    };
    const menuSoporte = {
      path: 'soporte/inbox',
      exact: true,
      icon: ExceptionOutlined,
      title: 'Bandeja de Soporte',
      component: TableSupport,
    };
    const correccionUsuario = {
      path: 'correcciones/editar/usuario',
      exact: true,
      title: 'Editar Usuario de S.U.T.',
      component: TableEditUser,
    };
    const correcionContribuyente = {
      path: 'correcciones/editar/contribuyente',
      exact: true,
      title: 'Editar Contribuyente',
      component: ConsultTaxpayer,
    };
    const correccionLiquidaciones = {
      path: ['correcciones/liquidaciones', 'correcciones/liquidaciones/:id'],
      exact: true,
      title: 'Corrección de Liquidaciones',
      component: AmendSettlements,
    };

    const correcionesAdministrativas = {
      path: 'correcciones',
      exact: true,
      icon: SwapOutlined,
      title: 'Correcciones Administrativas',
      subMenu: subMenuCorrecciones,
    };

    const asignarCarteras = {
      path: 'cobranzasFiscalizacion/carteras',
      exact: true,
      title: 'Carteras de Cobranzas',
      component: Wallets,
    };

    const cobranzas = {
      path: 'cobranzasFiscalizacion/cobranzas',
      exact: true,
      title: 'Cobranzas',
      component: TableCharge,
    };

    const fiscalizacion = {
      path: 'cobranzasFiscalizacion/fiscalizacion',
      exact: true,
      title: 'Fiscalización',
      component: TableInspection,
    };

    const subMenuCobranzas: RouteI[] = [];

    const cobranzasFiscalizacion = {
      path: 'cobranzasFiscalizacion',
      exact: true,
      title:
        user.institucion.cargo.id === CargoSedemat.Administrador || user.institucion.cargo.id === CargoSedemat.Master
          ? 'Cobranzas y Fiscalización'
          : user.institucion.cargo.id !== CargoSedemat.JefeFiscalizacion
            ? 'Cobranzas'
            : 'Fiscalización',
      icon: AccountBookOutlined,
      subMenu: subMenuCobranzas,
    };

    const subMenuReporteCaja = [
      {
        path: 'reportes/5',
        exact: false,
        title: 'Cierre de Caja',
      },
      {
        path: 'reportes/recibos',
        exact: false,
        title: 'Historico de Recibos',
        component: TableReceipt,
      },
    ];

    const reporteInternoAcumulado = {
      path: 'reportes/1',
      exact: false,
      title: 'Interno de Recaudación Acumulada',
    };

    const reporteAcumuladoAlcaldia = {
      path: 'reportes/2',
      exact: false,
      title: 'Acumulado para Alcaldía',
    };

    const reportePlanillasVigentes = {
      path: 'reportes/3',
      exact: false,
      title: 'Planillas Vigentes y Pagadas',
    };

    const reporteIVA = {
      path: 'reportes/4',
      exact: false,
      title: 'Reporte de I.V.A',
    };

    const reportIngresoTransf = {
      path: 'reportes/8',
      exact: false,
      title: 'Ingreso por transferencias',
    };

    const reporteCondo = {
      path: 'reportes/9',
      exact: false,
      title: 'Reporte Ingreso por Condominios',
    };

    const reporteTransfBanco = {
      path: 'reportes/10',
      exact: false,
      title: 'Ingreso por transferencias por banco',
    };

    const reporteCondoDisclosed = {
      path: 'reportes/11',
      exact: false,
      title: 'Reporte de Condominios por Liquidaciones',
    };

    const reportePagosAprobados = {
      path: 'reportes/13',
      exact: false,
      title: 'Reporte de pagos aprobados',
    };

    const reportePagos = {
      path: 'reportes/14',
      exact: false,
      title: 'Reporte de Pagos Tesorería',
    };

    // const reporteRecaudacion = {
    //   path: 'reportes/15',
    //   exact: false,
    //   title: 'Reporte de Recaudación',
    // };

    const reporteCreditoFiscal = {
      path: 'reportes/17',
      exact: false,
      title: 'Reporte de crédito fiscal',
    };

    const reportePagosRechazados = {
      path: 'reportes/18',
      exact: false,
      title: 'Reporte de Pagos Rechazados',
    };

    const reporteContribuyentesDeudores = {
      path: 'reportes/19',
      exact: false,
      title: 'Reporte de contribuyentes Deudores',
    };

    const reporteContribuyentesGeneral = {
      path: 'reportes/20',
      exact: false,
      title: 'Reporte de Contribuyentes General',
    };

    const reporteContribuyentesSinDeclarar = {
      path: 'reportes/21',
      exact: false,
      title: 'Reporte de Contribuyentes Sin Declarar',
    };
    
    const subMenuReportes: RouteI[] = [];

    const reportes = {
      path: 'reportes',
      exact: true,
      title: 'Reportes',
      icon: BarChartOutlined,
      subMenu: subMenuReportes,
    };

    const subMenuProcesosDirectivos: RouteI[] = [];

    const beneficiosTributables = {
      path: 'beneficiosTributables',
      exact: true,
      title: 'Beneficios Fiscales',
      component: BenefitTribTaxes,
    };

    const suiteSoporte = {
      path: 'suiteSoporte',
      exact: true,
      title: 'Suite de Soporte',
      component: SupportSuite,
    };

    const registroSucursal = {
      path: 'contribuyente/registroSucursal',
      exact: true,
      title: 'Registro Sucursal',
      component: InternalBranchRegister,
    };

    const cambioAE = {
      path: 'contribuyente/cambioLicencia',
      exact: true,
      title: 'Cambio de Actividades Económicas',
      component: ActivityChange,
    };

    const reparos = {
      path: 'reparos',
      exact: true,
      title: 'Liquidar Reparos',
      component: Fixes,
    };

    const agentesRetencion = {
      path: 'agentes',
      exact: true,
      title: 'Agentes de Retención',
      component: Agents,
    };

    const procesosDirectivos = {
      path: 'procesosDirectivos',
      exact: false,
      icon: ReconciliationOutlined,
      title: 'Procesos Directivos',
      subMenu: subMenuProcesosDirectivos,
    };

    const liquidarImpuestos = {
      path: 'impuestos/declarar',
      exact: false,
      title: user.tipoUsuario === 3 ? 'Declarar Impuestos' : 'Liquidar Impuestos',
      component: DeclareAnyTaxes,
    };

    const liquidarImpuestosAnualAE = {
      path: 'impuestos/anual/declarar',
      exact: false,
      title: user.tipoUsuario === 3 ? 'Declarar Impuestos Anual' : 'Liquidar Impuestos Anual',
      component: DeclareAnualAE,
    };

    const liquidarRetenciones = {
      path: 'impuestos/retenciones',
      exact: false,
      title: 'Declarar Retenciones',
      component: Retentions,
    };

    const pagosCpu = {
      path: 'tramites/pagosCpu',
      exact: true,
      title: 'Trámites CPU por pagar',
      component: TableCPUPayments,
      icon: CreditCardOutlined,
    };

    const subMenuImpuestos: RouteI[] = [];

    const liquidacionesEspeciales = {
      path: ['impuestos/especiales', 'impuestos/especiales/:id'],
      exact: true,
      title: 'Liquidaciones de Tasas e Impuestos',
      component: SpecialSettlements,
    };

    const liquidacionSustitiva = {
      path: 'impuestos/sustitutiva',
      exact: true,
      title: 'Declaración Sustitutiva',
      component: SubstituteStatement,
    };

    const liquidacionComplementaria = {
      path: 'impuestos/complementaria',
      exact: true,
      title: 'Declaración Complementaria',
      component: SupplementaryStatement,
    };

    const consultaDePagos = {
      path: 'pagos/consulta',
      exact: true,
      title: 'Consulta de Pagos',
      component: InternalPayments,
    };

    const consultaDeRetenciones = {
      path: 'retenciones/consulta',
      exact: true,
      title: 'Consulta de Retenciones',
      component: TableRetentions,
    };

    const liquidacionesPendientes = {
      path: 'impuestos/pendientes',
      exact: false,
      title: 'Liquidaciones Pendientes',
      component: PendingRequests,
    };

    const pagoConvenios = {
      path: 'impuestos/convenios',
      exact: false,
      title: 'Convenios',
      component: AgreementTaxPayer,
    };

    const impuestos = {
      path: 'impuestos',
      exact: true,
      title: 'Liquidación de Impuestos',
      icon: FileAddOutlined,
      subMenu: subMenuImpuestos,
    };

    const certificados = {
      path: 'certificado',
      exact: true,
      title: 'Generar Certificados',
      icon: ContainerOutlined,
      subMenu: [
        // {
        //   path: 'certificado/SM',
        //   exact: true,
        //   title: 'Solvencia Municipal',
        //   component: CertificadeView,
        // },
        {
          path: 'certificado/IU',
          exact: true,
          title: 'Inmueble Urbano',
          component: CertificadeView,
        },
        // {
        //   path: 'certificado/EL/generar',
        //   exact: true,
        //   title: 'Licencia de Licores',
        //   component: CertificadeForm,
        // },
      ],
    };

    const subMenuInmuebles: RouteI[] = [
      {
        path: 'inmueblesUrbanos/contribuyente',
        exact: true,
        title: 'Inmuebles por Contribuyente',
        component: TaxPayerUrbanEstates,
      },
    ];

    const inmuebles = {
      path: 'inmueblesUrbanos',
      exact: true,
      icon: HomeOutlined,
      title: 'Inmuebles Urbanos',
      subMenu: subMenuInmuebles,
    };

    const consultarInmueble = {
      path: 'inmueblesUrbanos/consultar',
      exact: false,
      title: 'Consultar Inmueble',
      component: ConsultProperty,
    };

    const registrarInmueble = {
      path: 'inmueblesUrbanos/registrar',
      exact: false,
      title: 'Registrar Inmueble',
      component: RegisterProperty,
    };

    const editarInmueble = {
      path: 'inmueblesUrbanos/editar',
      exact: false,
      title: 'Editar Inmueble',
      component: RegisterProperty,
    };

    const condominiums = {
      path: 'condominios',
      exact: true,
      icon: HomeFilled,
      title: 'Condominios',
      subMenu: [
        {
          path: 'condominios/registro',
          exact: true,
          title: 'Registro de Condominios',
          component: RegisterCodominium,
        },
      ],
    };

    const subMenuSM: RouteI[] = [
      {
        path: 'serviciosMunicipales/contribuyente',
        exact: true,
        title: 'Servicios Municipales por Contribuyente',
        component: TaxpayerServices,
      },
    ];

    const serviciosMunicipales = {
      path: 'serviciosMunicipales',
      exact: true,
      icon: FireOutlined,
      title: 'Servicios Municipales',
      subMenu: subMenuSM,
    };

    const nuevosContribuyentes = {
      path: 'contribuyente',
      exact: true,
      title: 'Nuevos Contribuyentes',
      icon: UserAddOutlined,
      subMenu: [
        {
          path: 'contribuyente/registro',
          exact: true,
          title: 'Registro de Contribuyente',
          component: InternalRegister,
        },
        {
          path: ['contribuyente/licencia', 'contribuyente/licencia/:id'],
          exact: true,
          title: 'Licencia de Actividades Económicas',
          component: InternalLicense,
        },
      ],
    };

    const licores = {
      path: '/licores',
      exact: true,
      title: 'Licencia de Licores',
      icon: FolderAddOutlined,
      subMenu: [
        {
          path: 'tramite/licores',
          exact: true,
          title: 'Solicitud de Licencia Licores',
          component: LicenseLiqueurForm,
        },
      ],
    };

    const declararVehiculos = {
      path: 'impuestos/vehiculosInfo',
      exact: false,
      title: `Tramitar Vehiculos`,
      component: GetVehicleInfo,
    };

    const auditoriaMovimientos = {
      path: 'procesos/auditoria-movimientos',
      exact: false,
      title: 'Auditoría de movimientos',
      component: TableAuditMovements,
      icon: FileSearchOutlined,
    };

    switch (user.institucion.cargo.id) {
      case CargoSedemat.Master:
        subMenuReportes.push(
          reporteInternoAcumulado,
          reporteAcumuladoAlcaldia,
          reportePlanillasVigentes,
          reporteIVA,
          reportIngresoTransf,
          reporteTransfBanco,
          reporteCondo,
          reporteCondoDisclosed,
          reportePagosAprobados,
          reportePagos,
          reportePagosRechazados,
          reporteContribuyentesGeneral,
          reporteContribuyentesDeudores,
          reporteContribuyentesSinDeclarar,
          // reporteRecaudacion,
          reporteCreditoFiscal
        );
        subMenuCobranzas.push(asignarCarteras, fiscalizacion);
        subMenuProcesosDirectivos.push(registroSucursal, beneficiosTributables, suiteSoporte, cambioAE, agentesRetencion);
        subMenuImpuestos.push(
          liquidarImpuestos,
          liquidarImpuestosAnualAE,
          liquidacionesEspeciales,
          reparos,
          liquidarRetenciones,
          liquidacionesPendientes,
          // liquidacionComplementaria,
          // liquidacionSustitiva,
          pagoConvenios,
          consultaDeRetenciones,
          consultaDePagos,
          declararVehiculos
        );
        subMenuCorrecciones.push(correccionLiquidaciones, correccionPagos, correccionUsuario, correcionContribuyente);
        subMenuInmuebles.push(consultarInmueble, registrarInmueble, editarInmueble);
        routes.push(
          procesosDirectivos,
          correcionesAdministrativas,
          cobranzasFiscalizacion,
          licores,
          inmuebles,
          // condominiums,
          // serviciosMunicipales,
          reportes,
          nuevosContribuyentes,
          impuestos,
          certificados,
          auditoriaMovimientos,
        );
        routes.push({
          path: 'contrib/consultar/solvente',
          exact: true,
          title: 'Consulta de Estatus Solvente',
          icon: UserOutlined,
          component: ConsultSolventStatus,
        });
        break;
      case CargoSedemat.MasterSoporte:
        subMenuReportes.push(
          reporteInternoAcumulado,
          reporteAcumuladoAlcaldia,
          reportePlanillasVigentes,
          reporteIVA,
          reportIngresoTransf,
          reporteTransfBanco,
          reporteCondo,
          reporteCondoDisclosed,
          reporteContribuyentesGeneral,
          reporteContribuyentesDeudores,
          reporteContribuyentesSinDeclarar,
        );
        subMenuCobranzas.push(asignarCarteras, fiscalizacion);
        subMenuProcesosDirectivos.push(registroSucursal, beneficiosTributables, suiteSoporte, /*cambioAE,*/ agentesRetencion);
        subMenuImpuestos.push(
          liquidarImpuestos,
          liquidarImpuestosAnualAE,
          liquidacionesEspeciales,
          reparos,
          liquidarRetenciones,
          liquidacionesPendientes,
          // liquidacionComplementaria,
          // liquidacionSustitiva,
          pagoConvenios,
          consultaDeRetenciones,
          consultaDePagos,
          declararVehiculos
        );
        subMenuCorrecciones.push(correccionPagos, correccionUsuario, correcionContribuyente);
        subMenuInmuebles.push(consultarInmueble, registrarInmueble, editarInmueble);
        routes.push(
          procesosDirectivos,
          correcionesAdministrativas,
          cobranzasFiscalizacion,
          licores,
          inmuebles,
          // condominiums,
          // serviciosMunicipales,
          reportes,
          nuevosContribuyentes,
          impuestos,
          certificados
        );
        routes.push({
          path: 'contrib/consultar/solvente',
          exact: true,
          title: 'Consulta de Estatus Solvente',
          icon: UserOutlined,
          component: ConsultSolventStatus,
        });
        break;
      case CargoSedemat.Administrador:
        subMenuReportes.push(
          reporteInternoAcumulado,
          reporteAcumuladoAlcaldia,
          reportePlanillasVigentes,
          reporteIVA,
          reportIngresoTransf,
          reporteTransfBanco,
          reporteCondo,
          {
            path: 'reportes/6',
            exact: false,
            title: 'Cierre de Todas las Cajas',
          }
        );
        subMenuCobranzas.push(asignarCarteras, fiscalizacion);
        subMenuProcesosDirectivos.push(registroSucursal, beneficiosTributables, suiteSoporte, /* cambioAE,*/ agentesRetencion);
        subMenuImpuestos.push(
          liquidarImpuestos,
          liquidacionesEspeciales,
          reparos,
          liquidarRetenciones,
          liquidacionesPendientes,
          // liquidacionComplementaria,
          // liquidacionSustitiva,
          pagoConvenios,
          consultaDeRetenciones,
          consultaDePagos
        );
        subMenuCorrecciones.push(correccionLiquidaciones, correccionPagos, correccionUsuario, correcionContribuyente);
        subMenuInmuebles.push(consultarInmueble, registrarInmueble, editarInmueble);
        routes.push(
          procesosDirectivos,
          correcionesAdministrativas,
          cobranzasFiscalizacion,
          // licores,
          inmuebles,
          condominiums,
          serviciosMunicipales,
          reportes,
          nuevosContribuyentes,
          impuestos,
          certificados
        );
        break;
      case CargoSedemat.GerenteGeneral:
        subMenuReportes.push(
          reporteInternoAcumulado,
          reporteAcumuladoAlcaldia,
          reportePlanillasVigentes,
          reporteIVA,
          reportIngresoTransf,
          reporteTransfBanco,
          reporteCondo,
          reporteCondoDisclosed,
          reportePagosAprobados,
          reportePagos,
          reportePagosRechazados,
          reporteContribuyentesGeneral,
          reporteContribuyentesDeudores,
          reporteContribuyentesSinDeclarar,
          // reporteRecaudacion
        );
        moneySubmenu.push(
          {
            path: 'fechaBancaria',
            exact: false,
            title: 'Fechas Bancarias',
            component: TableBankCalendar,
          },
          { path: 'finanzas/alicuotas', exact: true, title: 'Administrar Alicuotas', component: TableActivities }
        );
        subMenuCorrecciones.push(correccionPagos, correccionUsuario, correcionContribuyente, correccionLiquidaciones);
        subMenuProcesosDirectivos.push(beneficiosTributables, cambioAE, reparos, agentesRetencion, registroSucursal);
        subMenuImpuestos.push(
          liquidarImpuestos,
          liquidacionesEspeciales,
          liquidarRetenciones,
          liquidacionesPendientes,
          pagoConvenios,
          consultaDeRetenciones,
          consultaDePagos,
          reparos
        );
        subMenuSM.push({
          path: 'serviciosMunicipales/tasas',
          exact: true,
          title: 'Baremo de tarifas',
          component: Scale,
        });
        subMenuInmuebles.push(registrarInmueble, editarInmueble);
        routes.push(
          {
            path: 'finanzas',
            exact: true,
            icon: DollarOutlined,
            title: 'Finanzas',
            subMenu: moneySubmenu,
          },
          procesosDirectivos,
          correcionesAdministrativas,
          inmuebles,
          // licores,
          serviciosMunicipales,
          reportes,
          nuevosContribuyentes,
          impuestos
        );
        break;
      case CargoSedemat.GerenteGeneralE:
        routes.push({
          path: 'funcionarios',
          exact: false,
          icon: TeamOutlined,
          title: 'Administrar Usuarios',
          component: TableOfficials,
        });
        subMenuReportes.push(
          reporteInternoAcumulado,
          reporteAcumuladoAlcaldia,
          reportePlanillasVigentes,
          reporteIVA,
          reportIngresoTransf,
          reporteTransfBanco,
          reporteCondo,
          reporteCondoDisclosed,
          reportePagosAprobados,
          reportePagos,
          reportePagosRechazados,
          reporteContribuyentesGeneral,
          reporteContribuyentesDeudores,
          reporteContribuyentesSinDeclarar,
          // reporteRecaudacion
        );
        moneySubmenu.push(
          {
            path: 'fechaBancaria',
            exact: false,
            title: 'Fechas Bancarias',
            component: TableBankCalendar,
          },
          { path: 'finanzas/alicuotas', exact: true, title: 'Administrar Alicuotas', component: TableActivities }
        );
        subMenuCorrecciones.push(correccionPagos, correccionUsuario, correcionContribuyente, correccionLiquidaciones);
        subMenuProcesosDirectivos.push(beneficiosTributables, cambioAE, reparos, agentesRetencion, registroSucursal);
        subMenuImpuestos.push(
          liquidarImpuestos,
          liquidacionesEspeciales,
          liquidarRetenciones,
          liquidacionesPendientes,
          pagoConvenios,
          consultaDeRetenciones,
          consultaDePagos,
          reparos
        );
        subMenuSM.push({
          path: 'serviciosMunicipales/tasas',
          exact: true,
          title: 'Baremo de tarifas',
          component: Scale,
        });
        subMenuInmuebles.push(registrarInmueble, editarInmueble);
        routes.push(
          {
            path: 'finanzas',
            exact: true,
            icon: DollarOutlined,
            title: 'Finanzas',
            subMenu: moneySubmenu,
          },
          procesosDirectivos,
          correcionesAdministrativas,
          inmuebles,
          // licores,
          serviciosMunicipales,
          reportes,
          nuevosContribuyentes,
          impuestos,
          auditoriaMovimientos,
        );
        break;
      case CargoSedemat.GerenteGeneralA:
        subMenuReportes.push(
          reporteInternoAcumulado,
          reporteAcumuladoAlcaldia,
          reportePlanillasVigentes,
          reporteIVA,
          reportIngresoTransf,
          reporteCondo
        );
        subMenuProcesosDirectivos.push(beneficiosTributables, /*cambioAE,*/ reparos, agentesRetencion);
        subMenuImpuestos.push(
          liquidarImpuestos,
          liquidacionesEspeciales,
          liquidarRetenciones,
          liquidacionesPendientes,
          pagoConvenios,
          consultaDeRetenciones,
          consultaDePagos
        );
        routes.push(reportes, nuevosContribuyentes, impuestos);
        break;
      case CargoSedemat.GerenteAdministracion:
        subMenuReportes.push(
          reporteInternoAcumulado,
          reporteAcumuladoAlcaldia,
          reportePlanillasVigentes,
          reporteIVA,
          reportIngresoTransf,
          reporteTransfBanco,
          reportePagosAprobados,
          reportePagos,
          reportePagosRechazados
          // reporteRecaudacion
        );
        routes.push(
          {
            path: 'finanzas',
            exact: true,
            icon: DollarOutlined,
            title: 'Finanzas',
            subMenu: moneySubmenu,
          },
          reportes
        );
        break;
      case CargoSedemat.GerenteCobranzas:
        subMenuReportes.push(reporteInternoAcumulado, reporteAcumuladoAlcaldia, reportePlanillasVigentes, reporteIVA);
        subMenuProcesosDirectivos.push(beneficiosTributables, agentesRetencion);
        subMenuImpuestos.push(
          liquidarImpuestos,
          liquidacionesEspeciales,
          liquidarRetenciones,
          liquidacionesPendientes,
          // liquidacionComplementaria,
          // liquidacionSustitiva,
          pagoConvenios,
          consultaDeRetenciones,
          consultaDePagos
        );
        subMenuCobranzas.push(asignarCarteras);
        routes.push(reportes, cobranzasFiscalizacion, procesosDirectivos, impuestos);
        break;
      case CargoSedemat.GerentePoliticasTributarias:
        subMenuCorrecciones.push(correccionUsuario, correcionContribuyente /*cambioAE*/);
        subMenuProcesosDirectivos.push(beneficiosTributables, registroSucursal);
        subMenuReportes.push(reporteInternoAcumulado, reporteAcumuladoAlcaldia, reportePlanillasVigentes, reporteIVA);
        subMenuInmuebles.push(consultarInmueble, registrarInmueble, editarInmueble);
        subMenuImpuestos.push(
          liquidarImpuestos,
          reparos,
          liquidacionesEspeciales,
          liquidacionesPendientes,
          pagoConvenios
          // liquidacionComplementaria,
          // liquidacionSustitiva
        );
        routes.push(
          correcionesAdministrativas,
          reportes,
          inmuebles,
          nuevosContribuyentes,
          impuestos,
          condominiums,
          procesosDirectivos
        );
        break;
      case CargoSedemat.GerenteRecaudacion:
        subMenuCorrecciones.push(correccionPagos, consultaDePagos);
        subMenuReportes.push(
          reporteInternoAcumulado,
          reporteAcumuladoAlcaldia,
          reportePlanillasVigentes,
          reporteIVA,
          reportIngresoTransf,
          reporteTransfBanco,
          reporteCondo,
          reporteCondoDisclosed,
          reportePagosAprobados,
          reportePagos,
          reportePagosRechazados,
          // reporteRecaudacion,
          reporteCreditoFiscal,
          ...subMenuReporteCaja,
          {
            path: 'reportes/6',
            exact: false,
            title: 'Cierre de Todas las Cajas',
            // component: Report,
          }
        );

        subMenuImpuestos.push(
          // liquidarImpuestos,
          liquidacionesPendientes
          // liquidacionesEspeciales,
          // liquidacionComplementaria,
          // liquidacionSustitiva,
          // reparos,
          // pagoConvenios,
          // consultaDePagos
        );
        routes.push({
          path: 'finanzas',
          exact: true,
          icon: DollarOutlined,
          title: 'Finanzas',
          subMenu: [
            {
              path: 'validacionDePagos',
              exact: true,
              title: 'Validación de Pagos',
              component: ValidatePayments,
            },
          ],
        });
        routes.push(reportes, correcionesAdministrativas, impuestos);
        break;
      case CargoSedemat.DirectorUrbanismo:
        subMenuReportes.push(
          reporteInternoAcumulado,
          reporteAcumuladoAlcaldia,
          reportePlanillasVigentes,
          reporteIVA,
          reporteCondo,
          reporteCondoDisclosed
        );
        subMenuImpuestos.push(liquidacionesEspeciales, liquidacionesPendientes, pagoConvenios, consultaDePagos);
        routes.push(reportes, condominiums, nuevosContribuyentes, impuestos, menuSoporte);
        break;
      case CargoSedemat.JefeServiciosMunicipales:
        subMenuImpuestos.push(liquidarImpuestos /*, liquidacionComplementaria, liquidacionSustitiva*/);
        routes.push(serviciosMunicipales, impuestos);
        break;
      case CargoSedemat.JefeInmueblesUrbanos:
        subMenuImpuestos.push(liquidarImpuestos /*, liquidacionComplementaria, liquidacionSustitiva*/);
        routes.push(impuestos);
        break;
      case CargoSedemat.JefeActividadesEconomicas:
        subMenuCorrecciones.push(correccionUsuario, correcionContribuyente);
        subMenuImpuestos.push(
          liquidarImpuestos,
          reparos,
          // liquidacionComplementaria,
          // liquidacionSustitiva,
          liquidacionesPendientes,
          pagoConvenios
        );
        routes.push(correcionesAdministrativas, nuevosContribuyentes, impuestos);
        break;
      case CargoSedemat.JefeAuditorias:
        subMenuProcesosDirectivos.push(beneficiosTributables);
        subMenuImpuestos.push(
          liquidacionesEspeciales,
          reparos,
          liquidacionesPendientes,
          pagoConvenios,
        );
        subMenuReportes.push(
          reportePagos,
          reporteContribuyentesGeneral,
          reporteContribuyentesDeudores,
          reporteContribuyentesSinDeclarar,
          reporteCreditoFiscal
        );
        routes.push(procesosDirectivos, impuestos, reportes);
        break;
      case CargoSedemat.JefeContribuyentesEspeciales:
        subMenuProcesosDirectivos.push(agentesRetencion);
        subMenuImpuestos.push(
          liquidarImpuestos,
          liquidacionesPendientes,
          liquidacionesEspeciales,
          liquidarRetenciones,
          pagoConvenios
        );
        routes.push(procesosDirectivos, impuestos);
        break;
      case CargoSedemat.JefeDeTransacciones:
        subMenuCorrecciones.push(correccionUsuario, correcionContribuyente);
        subMenuImpuestos.push(
          liquidarImpuestos,
          reparos,
          liquidacionesEspeciales,
          // liquidacionComplementaria,
          // liquidacionSustitiva,
          liquidacionesPendientes,
          pagoConvenios
        );
        routes.push(correcionesAdministrativas, nuevosContribuyentes, impuestos);
        break;
      case CargoSedemat.JefeDeCaja:
        subMenuReporteCaja.push({
          path: 'reportes/6',
          exact: false,
          title: 'Cierre de Todas las Cajas',
        });
        subMenuReportes.push(...subMenuReporteCaja, reportIngresoTransf, reporteInternoAcumulado);
        subMenuCorrecciones.push(correcionContribuyente, correccionUsuario);
        // subMenuProcesosDirectivos.push(cambioAE);
        subMenuInmuebles.push(consultarInmueble, registrarInmueble, editarInmueble);
        subMenuImpuestos.push(
          liquidarImpuestos,
          reparos,
          liquidacionesEspeciales,
          liquidacionesPendientes,
          // liquidacionComplementaria,
          // liquidacionSustitiva,
          pagoConvenios,
          consultaDePagos,
          declararVehiculos
        );
        routes.push(reportes, impuestos, nuevosContribuyentes, /*procesosDirectivos,*/ inmuebles);

        break;
      case CargoSedemat.JefeContaduria:
        subMenuReporteCaja.push({
          path: 'reportes/6',
          exact: false,
          title: 'Cierre de Todas las Cajas',
          // component: Report,
        });
        subMenuReportes.push(...subMenuReporteCaja, reportIngresoTransf, reporteTransfBanco);
        routes.push(reportes);
        break;
      case CargoSedemat.JefeDeCuadra:
        subMenuReporteCaja.push({
          path: 'reportes/6',
          exact: false,
          title: 'Cierre de Todas las Cajas',
          // component: Report,
        });
        subMenuReportes.push(...subMenuReporteCaja);
        subMenuImpuestos.push(consultaDePagos);
        routes.push(reportes);
        break;
      case CargoSedemat.JefeFiscalizacion:
        subMenuReportes.push(reportePlanillasVigentes);
        subMenuImpuestos.push(liquidacionesPendientes, pagoConvenios);
        subMenuCobranzas.push(fiscalizacion);
        routes.push(reportes, cobranzasFiscalizacion, impuestos);
        break;
      case CargoSedemat.ConsultorLiquidaciones:
        subMenuImpuestos.push(liquidacionesPendientes);
        routes.push(impuestos);
        break;
      case CargoSedemat.Cajero:
        subMenuReportes.push(...subMenuReporteCaja);
        subMenuImpuestos.push(
          liquidarImpuestos,
          liquidacionesPendientes,
          liquidacionesEspeciales,
          pagoConvenios,
          consultaDePagos
        );
        routes.push(nuevosContribuyentes, reportes, impuestos);
        break;
      case CargoSedemat.CajeroIntegral:
        subMenuCorrecciones.push(correcionContribuyente, correccionUsuario);
        subMenuReportes.push(...subMenuReporteCaja);
        subMenuProcesosDirectivos.push(registroSucursal);
        subMenuInmuebles.push(consultarInmueble, registrarInmueble, editarInmueble);
        subMenuImpuestos.push(
          liquidarImpuestos,
          liquidacionesEspeciales,
          liquidacionesPendientes,
          liquidarImpuestosAnualAE,
          // liquidacionComplementaria,
          // liquidacionSustitiva,
          pagoConvenios,
          consultaDePagos,
          declararVehiculos
        );
        routes.push(/*procesosDirectivos,*/ reportes, nuevosContribuyentes, impuestos, inmuebles);
        break;
      case CargoSedemat.CajeroE:
        subMenuCorrecciones.push(correcionContribuyente, correccionUsuario);
        subMenuReportes.push(...subMenuReporteCaja);
        subMenuProcesosDirectivos.push(/*cambioAE,*/ registroSucursal);
        subMenuImpuestos.push(
          liquidarImpuestos,
          liquidacionesEspeciales,
          liquidacionesPendientes,
          consultaDePagos,
          pagoConvenios
        );
        routes.push(procesosDirectivos, reportes, correcionesAdministrativas, nuevosContribuyentes, impuestos);
        break;
      case CargoSedemat.JefeDeZona:
        subMenuReporteCaja.push({
          path: 'reportes/6',
          exact: false,
          title: 'Cierre de Todas las Cajas',
          // component: Report,
        });
        subMenuReportes.push(reporteInternoAcumulado, reportIngresoTransf, ...subMenuReporteCaja);
        subMenuImpuestos.push(
          liquidarImpuestos,
          reparos,
          liquidacionesEspeciales,
          liquidacionesPendientes,
          // liquidacionComplementaria,
          // liquidacionSustitiva,
          pagoConvenios,
          consultaDePagos
        );
        routes.push(reportes, impuestos);
        break;
      case CargoSedemat.AnalistaCondominios:
        subMenuReportes.push(...subMenuReporteCaja);
        subMenuImpuestos.push(liquidacionesEspeciales, liquidacionesPendientes, pagoConvenios, consultaDePagos);
        routes.push(reportes, condominiums, nuevosContribuyentes, impuestos);
        break;
      case CargoSedemat.analistaLiquidacionesEspeciales:
        subMenuCorrecciones.push(correccionUsuario, correcionContribuyente);
        subMenuImpuestos.push(
          liquidarImpuestos,
          reparos,
          // liquidacionComplementaria,
          // liquidacionSustitiva,
          liquidacionesPendientes,
          liquidacionesEspeciales
        );
        routes.push(correcionesAdministrativas, nuevosContribuyentes, impuestos);
        break;
      case CargoSedemat.AnalistaPoliticasTributarias:
        subMenuCorrecciones.push(correccionUsuario, correcionContribuyente);
        subMenuImpuestos.push(
          liquidarImpuestos,
          reparos,
          // liquidacionComplementaria,
          // liquidacionSustitiva,
          liquidacionesPendientes
        );
        routes.push(correcionesAdministrativas, nuevosContribuyentes, impuestos);
        break;
      case CargoSedemat.analistaInmueblesUrbanos:
        subMenuCorrecciones.push(correccionUsuario, correcionContribuyente);
        subMenuImpuestos.push(
          liquidarImpuestos,
          reparos,
          // liquidacionComplementaria,
          // liquidacionSustitiva,
          liquidacionesPendientes
        );
        subMenuInmuebles.push(consultarInmueble, editarInmueble, registrarInmueble);
        routes.push(correcionesAdministrativas, nuevosContribuyentes, impuestos, inmuebles, certificados);
        break;
      case CargoSedemat.analistaConsultorInmuebles:
        subMenuCorrecciones.push(correccionUsuario, correcionContribuyente);
        subMenuImpuestos.push(
          liquidarImpuestos,
          reparos,
          // liquidacionComplementaria,
          // liquidacionSustitiva,
          liquidacionesPendientes
        );
        subMenuInmuebles.pop();
        subMenuInmuebles.push(consultarInmueble);
        routes.push(correcionesAdministrativas, nuevosContribuyentes, impuestos, inmuebles);
        break;
      case CargoSedemat.AnalistaCobranzas:
        subMenuImpuestos.push(
          liquidarImpuestos,
          // liquidacionComplementaria,
          // liquidacionSustitiva,
          liquidarRetenciones,
          liquidacionesPendientes,
          pagoConvenios,
          consultaDeRetenciones,
          consultaDePagos
        );
        subMenuCobranzas.push(cobranzas);
        routes.push(cobranzasFiscalizacion, impuestos);
        break;
      case CargoSedemat.AnalistaLicores:
        break;
      case CargoSedemat.Soporte:
        subMenuCorrecciones.push(
          correccionPagos,
          consultaDePagos,
          correccionUsuario,
          correcionContribuyente
        );
        subMenuImpuestos.push(liquidacionesPendientes);
        routes.push(correcionesAdministrativas, impuestos, nuevosContribuyentes);
        break;
      case CargoSedemat.Auditor:
        routes.push(nuevosContribuyentes);
        break;
      case CargoSedemat.Validador:
        subMenuReportes.push(...subMenuReporteCaja);
        routes.push(
          {
            path: 'finanzas',
            exact: true,
            icon: DollarOutlined,
            title: 'Finanzas',
            subMenu: [
              {
                path: 'validacionDePagos',
                exact: true,
                title: 'Validación de Pagos',
                component: ValidatePayments,
              },
              {
                path: 'fechaBancaria',
                exact: false,
                title: 'Fechas Bancarias',
                component: TableBankCalendar,
              },
            ],
          },
          reportes
        );
        break;
    }
    if (user.institucion.cargo.id !== CargoSedemat.Validador)
      routes.push(
        {
          path: 'contribuyente',
          exact: true,
          title: 'Migración de Datos',
          icon: ImportOutlined,
          subMenu: [
            // {
            //   path: 'contribuyente/importar',
            //   exact: true,
            //   title: 'Importar contribuyente de GTIC',
            //   component: InternalImport,
            // },
            {
              path: 'contribuyente/enlace',
              exact: true,
              title: 'Enlace de Contribuyente',
              component: InternalLinking,
            },
          ],
        },
        {
          path: 'contribuyente/consulta',
          exact: true,
          title: 'Consulta de Contribuyente',
          icon: UserOutlined,
          component: ConsultTaxpayer,
        }
      );

    if (canSupport.includes(user.institucion.cargo.id)) routes.push(menuSoporte);

    if (
      (user.tipoUsuario === UserType.OfficialAdmin && user.institucion.id !== 10) ||
      havePrcd.includes(user?.institucion?.cargo?.id || 0)
    ) {
      routes.push({
        path: 'bandejas',
        exact: false,
        icon: InboxOutlined,
        title: 'Bandejas',
        component: TableProcedure,
      });
    }
  }
  //FIN MENU INTERNO SEDEMAT

  //MENU DE RUTAS CPU
  if (user.institucion?.nombreCorto === 'CPU') {
    const inmueblesUrbanos = {
      path: 'inmueblesUrbanos',
      exact: true,
      icon: HomeOutlined,
      title: 'Inmuebles Urbanos',
      subMenu: [
        {
          path: 'inmueblesUrbanos/registrar',
          exact: false,
          title: 'Registrar Inmueble',
          component: RegisterProperty,
        },
        {
          path: 'inmueblesUrbanos/editar',
          exact: false,
          title: 'Editar Inmueble',
          component: RegisterProperty,
        },
      ],
    };

    const subMenuReportes: RouteI[] = [];

    const reportes = {
      path: 'reportes',
      exact: true,
      title: 'Reportes',
      icon: BarChartOutlined,
      subMenu: subMenuReportes,
    };

    const reporteEvalTiempoPersonal = {
      path: 'reportes/12',
      exact: false,
      title: 'Reporte de tiempos del personal',
    };

    const menuSoporte = {
      path: 'soporte/inbox',
      exact: true,
      icon: ExceptionOutlined,
      title: 'Bandeja de Soporte',
      component: TableSupport,
    };

    switch (user.institucion.cargo.id) {
      case CargoCpu.Administrador:
        subMenuReportes.push(reporteEvalTiempoPersonal);
        routes.push(reportes);
        break;
      case CargoCpu.AnalistaValuacionFiscal:
        routes.push(inmueblesUrbanos);
        break;
      case CargoCpu.JefeValuacionFiscal:
        routes.push(inmueblesUrbanos, {
          path: 'finanzas/valoresFiscales',
          exact: true,
          icon: BankOutlined,
          title: 'Valores Fiscales',
          component: TableFiscalValue,
        });
        break;
      case CargoCpu.JefeCodigoCatastral:
        break;
      case CargoCpu.AnalistaCodigoCatastral:
        // const instCpu = institutions.findIndex((i) => i.nombreCorto === 'CPU');
        // const codCat = institutions[instCpu]?.tramitesDisponibles?.filter((t) => t.titulo.startsWith('Codigo Catastral'));
        // routes.push(
        //   {
        //     path: '/',
        //     exact: true,
        //     title: 'Codigo Catastral',
        //     subMenu: [
        //       {
        //         path: `tramite/${institutions[instCpu]?.id}/${codCat ? codCat[0].id : 0}`,
        //         exact: true,
        //         title: codCat ? (codCat[0].titulo.includes('para Casas') ? 'Para Casas' : 'Para Apartamentos') : 'XD',
        //       },
        //       {
        //         path: `tramite/${institutions[instCpu]?.id}/${codCat ? codCat[1].id : 0}`,
        //         exact: true,
        //         title: codCat ? (codCat[1].titulo.includes('para Casas') ? 'Para Casas' : 'Para Apartamentos') : 'XD',
        //       },
        //     ],
        //   },
        // );
        break;
      case CargoCpu.AnalistaNomenclatura:
        // const instCpu2 = institutions.findIndex((i) => i.nombreCorto === 'CPU');
        // const nom = institutions[instCpu2]?.tramitesDisponibles?.filter((t) => t.titulo.startsWith('Constancia de Nomenclatura'));
        // routes.push(
        //   {
        //     path: '/',
        //     exact: true,
        //     title: 'Nomenclatura',
        //     subMenu: [
        //       {
        //         path: `tramite/${institutions[instCpu2]?.id}/${nom ? nom[0].id : 0}`,
        //         exact: true,
        //         title: nom ? nom[0].titulo : 'XD',
        //       },
        //     ],
        //   },
        // );
        break;
      case CargoCpu.JefeNomenclatura:
        break;
    }

    if (canSupport.includes(user.institucion.cargo.id)) routes.push(menuSoporte);
  }
  //FIN MENU CPU

  //MENU DE RUTAS ECODEBA
  if (user?.institucion?.id === 10) {
    const liquidacionesPendientes = {
      path: 'ecodeba/impuestos/pendientes',
      exact: false,
      title: 'Liquidaciones Pendientes',
      component: PendingRequests,
      icon: FileTextOutlined,
    };

    const tarifaAseo = {
      path: 'ecodeba/tarifa/aseo',
      exact: true,
      icon: FileSyncOutlined,
      title: 'Liquidar tarifa de Aseo',
      component: CleaningFee,
    };

    const nuevosContribuyentes = {
      path: 'contribuyente',
      exact: true,
      title: 'Nuevos Contribuyentes',
      icon: UserAddOutlined,
      subMenu: [
        {
          path: 'contribuyente/registro',
          exact: true,
          title: 'Registro de Contribuyente',
          component: InternalRegister,
        },
      ],
    };

    const subMenuMigracionDeDatos: RouteI[] = [];

    const migracionDeDatos = {
      path: 'contribuyente',
      exact: true,
      title: 'Migración de Datos',
      icon: ImportOutlined,
      subMenu: subMenuMigracionDeDatos,
    };

    const enlaceDeContribuyente = {
      path: 'contribuyente/enlace',
      exact: true,
      title: 'Enlace de Contribuyente',
      component: InternalLinking,
    };
    const consultaContribuyente = {
      path: 'contribuyente/consulta',
      exact: true,
      title: 'Consulta de Contribuyente',
      icon: UserOutlined,
      component: ConsultTaxpayer,
    };

    const subMenuCorrecciones: RouteI[] = [];

    const correccionPagos = {
      path: 'correcciones/pagos',
      exact: true,
      title: 'Corrección de Pagos',
      component: AmendPayments,
    };
    const correccionUsuario = {
      path: 'correcciones/editar/usuario',
      exact: true,
      title: 'Editar Usuario de S.U.T.',
      component: TableEditUser,
    };
    const correcionContribuyente = {
      path: 'correcciones/editar/contribuyente',
      exact: true,
      title: 'Editar Contribuyente',
      component: ConsultTaxpayer,
    };
    const correccionLiquidaciones = {
      path: ['correcciones/liquidaciones', 'correcciones/liquidaciones/:id'],
      exact: true,
      title: 'Corrección de Liquidaciones',
      component: AmendSettlements,
    };

    const correcionesAdministrativas = {
      path: 'correcciones',
      exact: true,
      icon: SwapOutlined,
      title: 'Correcciones Administrativas',
      subMenu: subMenuCorrecciones,
    };

    const reporteInternoAcumulado = {
      path: 'reportes/1',
      exact: false,
      title: 'Interno de Recaudación Acumulada',
    };

    const reporteTransfBanco = {
      path: 'reportes/10',
      exact: false,
      title: 'Ingreso por transferencias por banco',
    };

    const reportePagosAprobados = {
      path: 'reportes/13',
      exact: false,
      title: 'Reporte de pagos aprobados',
    };

    const reportePagos = {
      path: 'reportes/14',
      exact: false,
      title: 'Reporte de pagos',
    };

    // const reporteRecaudacion = {
    //   path: 'reportes/15',
    //   exact: false,
    //   title: 'Reporte de Recaudación',
    // };

    const reporteGlobalLiquidadoPagado = {
      path: 'reportes/16',
      exact: false,
      title: 'Reporte Global Liquidado y Pagado',
    };

    const reportePagosRechazados = {
      path: 'reportes/18',
      exact: false,
      title: 'Reporte de Pagos Rechazados',
    };

    const subMenuReportes: RouteI[] = [];

    const reportes = {
      path: 'reportes',
      exact: true,
      title: 'Reportes',
      icon: BarChartOutlined,
      subMenu: subMenuReportes,
    };

    const subMenuReporteCaja = [
      {
        path: 'reportes/5',
        exact: false,
        title: 'Cierre de Caja',
      },
      {
        path: 'reportes/recibos',
        exact: false,
        title: 'Historico de Recibos',
        component: TableReceipt,
      },
    ];

    const cierreTodosCajas = {
      path: 'reportes/6',
      exact: false,
      title: 'Cierre de Todas las Cajas',
    };

    const consultaDePagos = {
      path: 'pagos/consulta',
      exact: true,
      title: 'Consulta de Pagos',
      component: InternalPayments,
    };

    switch (user.institucion.cargo.id) {
      case CargoEcodeba.Master:
        subMenuReportes.push(
          reporteTransfBanco,
          reportePagosAprobados,
          reportePagos,
          reportePagosRechazados,
          cierreTodosCajas,
          reporteGlobalLiquidadoPagado
        );
        subMenuCorrecciones.push(
          correccionPagos,
          correccionUsuario,
          correcionContribuyente,
          consultaDePagos
        );
        routes.push(
          liquidacionesPendientes,
          tarifaAseo,
          nuevosContribuyentes,
          reportes,
          migracionDeDatos,
          correcionesAdministrativas
        );
        break;
      case CargoEcodeba.Cajero:
        subMenuReportes.push(...subMenuReporteCaja);
        routes.push(liquidacionesPendientes, nuevosContribuyentes, tarifaAseo, reportes);
        break;
      case CargoEcodeba.GestionAdministrativa:
        subMenuReportes.push(reporteTransfBanco, reportePagosAprobados);
        subMenuCorrecciones.push(correccionPagos, correcionContribuyente);
        subMenuMigracionDeDatos.push(consultaContribuyente);
        routes.push(liquidacionesPendientes, reportes, migracionDeDatos, correcionesAdministrativas);
        break;
      case CargoEcodeba.GestionGerencial:
        subMenuReportes.push(reporteTransfBanco, reportePagosAprobados);
        subMenuCorrecciones.push(correccionPagos, correcionContribuyente);
        subMenuMigracionDeDatos.push(consultaContribuyente);
        routes.push(liquidacionesPendientes, nuevosContribuyentes, reportes, correcionesAdministrativas);
        break;
    }
  }
  //FIN MENU DE RUTAS ECODEBA

  if (user.tipoUsuario === UserType.OfficialAdmin && user.institucion.nombreCorto === 'SAGAS') {
    routes.push({
      path: 'serviciosMunicipales',
      exact: true,
      icon: FireOutlined,
      title: 'Servicios Municipales',
      subMenu: [
        {
          path: 'serviciosMunicipales/contribuyente',
          exact: true,
          title: 'Servicios Municipales por Contribuyente',
          component: TaxpayerServices,
        },
      ],
    });
    routes.push({
      path: 'liquidaciones/SAGAS',
      exact: true,
      icon: FileOutlined,
      title: 'Liquidaciones de Gas',
      component: SMSettlements,
    });
  }

  // if (user.tipoUsuario === UserType.OfficialAdmin && user.institucion.nombreCorto === 'IMAU') {
  //   routes.push({
  //     path: 'liquidaciones/IMAU',
  //     exact: true,
  //     icon: FileOutlined,
  //     title: 'Liquidaciones de Aseo',
  //     component: SMSettlements,
  //   });
  // }

  // if (
  //   (user.tipoUsuario === UserType.OfficialAdmin || user.tipoUsuario === UserType.OfficialChief) &&
  //   user.institucion.nombreCorto === 'CPU'
  // ) {
  //   const subMenu: RouteI[] = [
  //     {
  //       path: 'liquidaciones/CPU',
  //       exact: true,
  //       title: 'Liquidaciones de CPU',
  //       component: SMSettlements,
  //     },
  //   ];

  //   if (user.tipoUsuario === UserType.OfficialAdmin) {
  //     subMenu.push({
  //       path: ['impuestos/especiales', 'impuestos/especiales/:id'],
  //       exact: true,
  //       title: 'Liquidaciones Especiales',
  //       component: SpecialSettlements,
  //     });
  //   }

  //   routes.push({
  //     path: 'procesosDirectivos',
  //     exact: false,
  //     icon: ReconciliationOutlined,
  //     title: 'Procesos Directivos',
  //     subMenu,
  //   });
  // }

  if (user.tipoUsuario === UserType.External) {
    const inst: RouteI[] = institutions
      .filter(
        (i) =>
          i.nombreCorto !== 'ABMM' &&
          i.nombreCorto !== 'PMM' &&
          i.nombreCorto !== 'IMA' &&
          i.nombreCorto !== 'SEDETEMA' &&
          i.nombreCorto !== 'SAT'
      )
      .map((i) => ({
        path: '/',
        exact: true,
        short: i.nombreCorto === 'SAT' ? 'SAMAT' : i.nombreCorto,
        title: i.nombreCompleto,
        subMenu: i.tramitesDisponibles
          ?.filter((t) => !t.titulo.includes('Permiso de Habitabilidad'))
          .filter((t) => !t.titulo.includes('Permiso de Condiciones Habitables'))
          .filter((t) => !t.titulo.includes('Codigo Catastral'))
          .filter((t) => !t.titulo.includes('Conformidad de la Edificación y Uso'))
          .map((t) => ({
            path: `tramite/${i.id}/${t.id}`,
            exact: true,
            title: t.titulo,
          })),
      }));

    let subMenuSedemat = [
      // {
      //   path: '/',
      //   exact: true,
      //   title: 'Licencia de Actividades Económicas',
      //   icon: FolderAddOutlined,
      //   subMenu: [
      //     {
      //       path: 'tramite/9/28',
      //       exact: true,
      //       title: 'Solicitud de Licencia Permanente',
      //     },
      //     {
      //       path: 'tramite/9/36',
      //       exact: true,
      //       title: 'Solicitud de Licencia Temporal',
      //     },
      //   ],
      // },
      {
        path: 'contribuyente/registroSucursal',
        exact: true,
        title: 'Registro Sucursal',
      },
      // {
      //   path: 'contrib/consultar',
      //   exact: true,
      //   title: 'Consulta de Contribuyente',
      //   icon: UserOutlined,
      // },
      {
        path: 'impuestos/declarar',
        exact: true,
        title: 'Declarar Impuestos',
        icon: FileAddOutlined,
      },
      {
        path: 'impuestos/sustitutiva',
        exact: true,
        title: 'Declaración Sustitutiva',
        icon: SwapOutlined,
      },
      {
        path: 'impuestos/complementaria',
        exact: true,
        title: 'Declaración Complementaria',
        icon: AppstoreAddOutlined,
      },
      {
        path: ['impuestos/especiales', 'impuestos/especiales/:id'],
        exact: true,
        title: 'Liquidaciones de Timbres y/o Tasas',
        component: SpecialSettlements,
        icon: FileAddOutlined,
      },
      {
        path: 'impuestos/anual/declarar',
        exact: false,
        title: 'Declarar Impuestos Anual',
        component: DeclareAnualAE,
        icon: SwapOutlined,
      },
      {
        path: 'impuestos/pagar',
        exact: true,
        title: 'Pagar Impuestos',
        icon: CreditCardFilled,
      },
      {
        path: 'impuestos/retenciones/consulta',
        exact: true,
        title: 'Consulta de Retenciones',
        icon: FolderViewOutlined,
      },
      {
        path: 'impuestos/convenios',
        exact: true,
        title: 'Convenios',
        icon: ScheduleOutlined,
      },
      {
        path: 'impuestos/vehiculos',
        exact: true,
        title: 'Vehículos',
        icon: CarOutlined,
      },
      {
        path: 'inmuebles/documentos/cargar',
        exact: true,
        title: 'Cargar documentos de Inmueble',
        icon: HomeOutlined,
      },
       {
      path: 'contribuyente/documentosRIM',
      exact: true,
      title: 'Cargar documentos R.I.M.',
      icon: FileSearchOutlined,
      component: RimDocuments,
    },
    ];

    let subMenuDocumentosRIMPendientes = [
      {
        path: 'contribuyente/documentosRIM',
        exact: true,
        title: 'Cargar documentos R.I.M.',
        icon: FileSearchOutlined,
        component: RimDocuments,
      },
    ];

    let instNew: RouteI[] = [
      {
        path: '/',
        exact: true,
        short: 'SATSFER',
        title: 'Servicio Autonomo de Administración Tributaria de San Fernando de Apure',
        subMenu: user.contribuyente?.verificacionTelefono
          ? subMenuSedemat
          : [
              // {
              //   path: 'impuestos/enlazar',
              //   exact: true,
              //   title: 'Enlazar cuenta de SAT',
              //   icon: LinkOutlined
              // },
              {
                path: 'tramite/9/27',
                exact: true,
                title: 'Registro de Contribuyente',
                icon: UserAddOutlined,
              },
              {
                path: 'impuestos/vehiculos',
                exact: true,
                title: 'Vehículos',
                icon: CarOutlined,
              },
            ],
        // subMenu: [
        //   {
        //     path: 'mantenimiento/mantenimiento',
        //     exact: true,
        //     title: 'Mantenimiento',
        //   },
        // ],
      },
    ];

    instNew.push({
      path: ['impuestos/especiales', 'impuestos/especiales/:id'],
      exact: true,
      title: '',
      component: SpecialSettlements,
    });

    instNew.push({
      path: 'contribuyente/documentosRIM',
      exact: true,
      title: '',
      component: RimDocuments,
    });

    if (user.contribuyente?.esAgenteRetencion)
      subMenuSedemat.unshift({
        path: 'impuestos/retenciones',
        exact: true,
        title: 'Declarar Retenciones',
        icon: PercentageOutlined,
      });
    if (!!user.contribuyente)
      subMenuSedemat.push({
        path: 'reportes/7',
        exact: false,
        title: 'Reporte de Cierre Definitivo',
        icon: BarChartOutlined,
      });
    inst.push({
      path: '/',
      exact: true,
      short: 'SATSFER',
      title: 'Servicio Autonomo de Administración Tributaria de San Fernando de Apure',
      subMenu: user.contribuyente?.verificacionTelefono
        ? subMenuSedemat
        : [
            // {
            //   path: 'impuestos/enlazar',
            //   exact: true,
            //   title: 'Enlazar cuenta de SAT',
            //   icon: LinkOutlined
            // },
            // {
            //   path: 'tramite/9/27',
            //   exact: true,
            //   title: 'Registro de Contribuyente',
            //   icon: UserAddOutlined,
            // },
            {
              path: 'impuestos/vehiculos',
              exact: true,
              title: 'Vehículos',
              icon: CarOutlined,
            },
          ],
      // subMenu: [
      //   {
      //     path: 'mantenimiento/mantenimiento',
      //     exact: true,
      //     title: 'Mantenimiento',
      //   },
      // ],
    });

    // ECODEBA
    // instNew.push({
    //   path: '/',
    //   exact: true,
    //   short: 'ECODEBA',
    //   title: 'Empresa Ecologica Para El Desarrollo Barines S.A',
    //   subMenu: [
    //     // {
    //     //   path: 'ecodeba/tarifa/aseo',
    //     //   exact: true,
    //     //   icon: FileSyncOutlined,
    //     //   title: 'Liquidar tarifa de Aseo',
    //     // },
    //     // {
    //     //   path: 'ecodeba/impuestos/pagar',
    //     //   exact: false,
    //     //   title: 'Liquidaciones Pendientes',
    //     //   icon: FileTextOutlined,
    //     // },
    //     {
    //       path: '',
    //       exact: false,
    //       title: 'Sistema Ecodeba',
    //       link: 'https://sigat.ecodeba.com/ingresar',
    //     },
    //   ],
    // });

    const instSagas = institutions.findIndex((i) => i.nombreCorto === 'SAGAS');
    const permisoHab = institutions[instSagas]?.tramitesDisponibles?.filter((t) =>
      t.titulo.startsWith('Permiso de Habitabilidad')
    );
    inst[instSagas]?.subMenu?.push(
      ...[
        {
          path: '/',
          exact: true,
          title: 'Permiso de Habitabilidad',
          subMenu: [
            {
              path: `tramite/${institutions[instSagas]?.id}/${permisoHab ? permisoHab[0].id : 0}`,
              exact: true,
              title: permisoHab
                ? permisoHab[0].titulo.includes('con Instalaciones')
                  ? 'Con Instalación de Servicio de Gas'
                  : 'Sin Instalación de Servicio de Gas'
                : 'XD',
            },
            {
              path: `tramite/${institutions[instSagas]?.id}/${permisoHab ? permisoHab[1].id : 0}`,
              exact: true,
              title: permisoHab
                ? permisoHab[1].titulo.includes('con Instalaciones')
                  ? 'Con Instalación de Servicio de Gas'
                  : 'Sin Instalación de Servicio de Gas'
                : 'XD',
            },
          ],
        },
      ]
    );
    const condHab = institutions
      .find((i) => i.nombreCorto === 'SAGAS')
      ?.tramitesDisponibles?.filter((t) => t.titulo.startsWith('Permiso de Condiciones Habitables'));
    inst[instSagas]?.subMenu?.push(
      ...[
        {
          path: '/',
          exact: true,
          title: 'Permiso de Condiciones Habitables',
          subMenu: [
            {
              path: `tramite/${institutions[instSagas]?.id}/${condHab ? condHab[0].id : 0}`,
              exact: true,
              title: condHab
                ? condHab[0].titulo.includes('con Instalaciones')
                  ? 'Con Instalación de Servicio de Gas'
                  : 'Sin Instalación de Servicio de Gas'
                : 'XD',
            },
            {
              path: `tramite/${institutions[instSagas]?.id}/${condHab ? condHab[1].id : 0}`,
              exact: true,
              title: condHab
                ? condHab[1].titulo.includes('con Instalaciones')
                  ? 'Con Instalación de Servicio de Gas'
                  : 'Sin Instalación de Servicio de Gas'
                : 'XD',
            },
          ],
        },
      ]
    );
    const instCpu = institutions.findIndex((i) => i.nombreCorto === 'CPU');
    const codCat = institutions[instCpu]?.tramitesDisponibles?.filter((t) => t.titulo.startsWith('Codigo Catastral'));
    inst[instCpu]?.subMenu?.push(
      ...[
        {
          path: '/',
          exact: true,
          title: 'Codigo Catastral',
          subMenu: [
            {
              path: `tramite/${institutions[instCpu]?.id}/${codCat ? codCat[0].id : 0}`,
              exact: true,
              title: codCat ? (codCat[0].titulo.includes('para Casas') ? 'Para Casas' : 'Para Apartamentos') : 'XD',
            },
            {
              path: `tramite/${institutions[instCpu]?.id}/${codCat ? codCat[1].id : 0}`,
              exact: true,
              title: codCat ? (codCat[1].titulo.includes('para Casas') ? 'Para Casas' : 'Para Apartamentos') : 'XD',
            },
          ],
        },
      ]
    );

    const usoConforme = institutions[instCpu]?.tramitesDisponibles?.filter((t) =>
      t.titulo.startsWith('Conformidad de la Edificación y Uso')
    );
    inst[instCpu]?.subMenu?.push(
      ...[
        {
          path: '/',
          exact: true,
          title: 'Conformidad de la Edificación y Uso',
          subMenu: [
            {
              path: `tramite/${institutions[instCpu]?.id}/${usoConforme ? usoConforme[0].id : 0}`,
              exact: true,
              title: usoConforme
                ? usoConforme[0].titulo.includes('Industriales')
                  ? 'Actividades Económicas Comerciales e Industriales'
                  : usoConforme[0].titulo.includes('Educativas')
                    ? 'Unidades Educativas'
                    : 'Locales en Centros Comerciales'
                : 'XD',
            },
            {
              path: `tramite/${institutions[instCpu]?.id}/${usoConforme ? usoConforme[1].id : 0}`,
              exact: true,
              title: usoConforme
                ? usoConforme[1].titulo.includes('Industriales')
                  ? 'Actividades Económicas Comerciales e Industriales'
                  : usoConforme[1].titulo.includes('Educativas')
                    ? 'Unidades Educativas'
                    : 'Locales en Centros Comerciales'
                : 'XD',
            },
            {
              path: `tramite/${institutions[instCpu]?.id}/${usoConforme ? usoConforme[2].id : 0}`,
              exact: true,
              title: usoConforme
                ? usoConforme[2].titulo.includes('Industriales')
                  ? 'Actividades Económicas Comerciales e Industriales'
                  : usoConforme[2].titulo.includes('Educativas')
                    ? 'Unidades Educativas'
                    : 'Locales en Centros Comerciales'
                : 'XD',
            },
          ],
        },
      ]
    );
    inst[instCpu].subMenu = inst[instCpu]?.subMenu?.filter(
      (el) => !el.title.includes('RRI') && !el.title.includes('Conformidad')
    );
    // instNew.push(inst[instCpu]);
    routes.push(...instNew);
    console.log({ routes, instNew });
  }

  if (user.tipoUsuario === UserType.OfficialAdmin || user.tipoUsuario === UserType.SuperUser) {
    routes.unshift({
      path: 'funcionarios',
      exact: false,
      icon: TeamOutlined,
      title: 'Administrar Usuarios',
      component: TableOfficials,
    });
  }

  if (user.institucion && user.institucion.id === 0 && user.tipoUsuario === UserType.OfficialAdmin) {
    routes.push({
      path: ['casosSociales', 'casosSociales/:id'],
      exact: true,
      title: 'Casos Sociales',
      icon: FolderOpenFilled,
      component: AffairsForm,
    });
  }

  if (user.institucion && user.institucion.nombreCorto === 'SEDETEMA' && user.tipoUsuario === UserType.Official) {
    routes.push({
      path: 'tasaDeSalida',
      exact: true,
      title: 'Tasa de Salida',
      icon: FolderOpenFilled,
      component: OfficialPFForm,
    });
  }

  //Rutas para bandeja de multas 6 = Ima y 7 = POLICIA
  if (user.institucion && (user.institucion.id === 6 || user.institucion.id === 7)) {
    if (user.institucion?.cargo?.id !== 52) {
      routes.push({
        path: 'crearMulta',
        exact: false,
        title: 'Crear Multa',
        icon: AlertOutlined,
        component: user.institucion.id === 7 ? PoliceTicketForm : IMATicketForm,
      });
    }
  }

  if (user.institucion?.id === 7 && user.institucion?.cargo?.id !== 51) {
    routes.push({
      path: 'bandejas',
      exact: false,
      icon: InboxOutlined,
      title: 'Bandejas',
      component: TableProcedure,
    });
  }

  if (user.institucion?.id !== 6 && user.institucion?.id !== 7 && user.institucion?.id !== 9) {
    routes.push({
      path: 'bandejas',
      exact: false,
      icon: InboxOutlined,
      title: 'Bandejas',
      component: TableProcedure,
    });
  }

  // Asistente Virtual
  // if ([CargoSedemat.Master, CargoSedemat.GerenteGeneral].includes(user?.institucion?.cargo?.id ?? 0)) {
  //   routes.push({
  //     path: 'virtualAssistant',
  //     exact: true,
  //     title: 'Asistente Virtual ',
  //     component: VirtualAssistant,
  //     icon: VirtualAssistantIcon as React.ForwardRefExoticComponent<any>,
  //   });
  // }

  // Bitácora - Solo para ciertos cargos de SAT (SEDEMAT)
  if (
    user?.institucion?.nombreCorto === 'SAT' &&
    [CargoSedemat.Master, CargoSedemat.MasterSoporte, CargoSedemat.GerenteGeneralE].includes(user?.institucion?.cargo?.id ?? 0)
  ) {
    routes.push({
      path: 'procesos/bitacora',
      exact: true,
      title: 'Bitacora',
      component: TableMovements,
      icon: CopyOutlined,
    });
  }

  return routes;
};
